<template>
    <div class="bigEvents">
        <div class="swiper-container" id="bigEvents">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item ,index) in arrs" :key="index">
                  <img v-if="!item.videoSrc" :src="item.thumbnail" alt="" @click="imglink(item.extUrl)">
                  <img v-else :src="item.videoCoverImgUrl" @click="showVideo(item.videoSrc)"></img>
                </div>
                <!--<div class="swiper-slide">Slide 2</div>-->
                <!--<div class="swiper-slide">Slide 3</div>-->
                <!--<div class="swiper-slide">Slide 4</div>-->
                <!--<div class="swiper-slide">Slide 5</div>-->
                <!--<div class="swiper-slide">Slide 6</div>-->
                <!--<div class="swiper-slide">Slide 7</div>-->
                <!--<div class="swiper-slide">Slide 8</div>-->
                <!--<div class="swiper-slide">Slide 9</div>-->
                <!--<div class="swiper-slide">Slide 10</div>-->
            </div>
            <!-- Add Pagination -->
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>
        <div class="zhezhao1"></div>
        <div class="zhezhao2"></div>

        <p class="title">{{name}}</p>
        <div class="text">
            <p>{{desc}}</p>
            <span>{{time}}</span>
        </div>
    </div>

</template>

<script>
  import img from '../../assets/img/temp/c.png'
    export default {
        name: 'bigEvents',
        props: {
            pluginJson: {
                type: Array
            }
            // pluginIndex: {
            //     type: String
            // }
        },
        data () {
            return {
              arrs:[],
              activeIndex: 0,
              arr: [ 1, 2,3,4 ,5, 6, 7],
              desc:'',
              time:'',
              name:'',
              extUrl:'',
              // currindex:0,

              // arrs:[
              //   {
              //     name:'区域品牌大事记',
              //     videoIntro:'',
              //     thumbnail:img,
              //     time:'2017年10月',
              //     text:'燕谷房开年大会价值峰会成功举办1'
              //   }, {
              //     name:'区域品牌大事记',
              //     videoIntro:'',
              //     thumbnail:img,
              //     time:'2017年10月',
              //     text:'燕谷房开年大会价值峰会成功举办2'
              //   }, {
              //     name:'区域品牌大事记',
              //     videoIntro:'',
              //     thumbnail:img,
              //     time:'2017年10月',
              //     text:'燕谷房开年大会价值峰会成功举办3'
              //   }, {
              //     name:'区域品牌大事记',
              //     videoIntro:'',
              //     thumbnail:img,
              //     time:'2017年10月',
              //     text:'燕谷房开年大会价值峰会成功举办4'
              //   }
              // ]

            }
        },
        created () {
        },
        mounted () {
          console.log('bigevents',this.pluginJson)

          this.pluginJson.forEach((material) => {
            let obj={}
            obj['name']=material['name']
            obj['description']=material['description']
            obj['desc']=material['description'].split('#')[0]
            obj['time']=material['description'].split('#')[1]
            obj['extUrl']=material['extUrl']
            obj['thumbnail']=material['thumbnail']
            obj['videoCoverImgUrl']=material['video']['videoCoverImgUrl']  //视频表面
            obj['videoSrc']=material['video']['videoIntro'] //视频url
            this.arrs.push(obj)
          })

            let that = this
            this.$nextTick(() => {
              that.name=that.arrs[1]['name']
              that.time=that.arrs[1]['time']
              that.desc=that.arrs[1]['desc']
              that.extUrl=that.arrs[1]['extUrl']
              // window.bigEventsSwiper = new Swiper('#bigEvents', {
              window.bigEventsSwiper =new Swiper('#bigEvents', {
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                paginationClickable: true,
                spaceBetween: 80,
                effect: 'coverflow',
                centeredSlides: true,
                initialSlide:1,
                slidesPerView: 'auto',
                loop: true,
                // speed: 4000,
                autoplay: {
                  disableOnInteraction: false, // 鼠标滑动后继续自动播放
                  delay: 4000, //4秒切换一次
                },
                // autoplay:2000,
                // autoplay: {
                //     disableOnInteraction: false,
                // },
                //   loopedSlides: 2,
                coverflowEffect: {
                  rotate: 0,
                  stretch: -50,
                  depth:100,
                  modifier: 2,
                  slideShadows: false,
                },
                on:{
                  slideChange:function () {
                    that.name=that.arrs[this.realIndex]['name']
                    that.time=that.arrs[this.realIndex]['time']
                    that.desc=that.arrs[this.realIndex]['desc']
                    that.extUrl=that.arrs[this.realIndex]['extUrl']
                  }
                }
              });
              console.log('window.bigEventsSwiper',window.bigEventsSwiper)

              window.bigEventsSwiper.el.onmouseover = function(){ //鼠标放上暂停轮播
                window.bigEventsSwiper.autoplay.stop();
              }
              window.bigEventsSwiper.el.onmouseleave = function(){
                window.bigEventsSwiper.autoplay.start();
              }
            })

        },
        watch: {
            pluginJson: {
                handler(newvalue,oldvalue){
                },
                deep: true
            }
        },
        methods: {
          imglink(url){
            if(url.indexOf('http')> -1){
              window.open(url, '_blank')
            }
          },
          showVideo(videoSrc){
            console.log(videoSrc)
            this.$emit('showMedia',{"url":videoSrc,'type':'video'})
          },
            changeIndex (index) {
                if (this.activeIndex !== index) {
                    this.activeIndex = index
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    @function rem($px) {
        @return $px * (1/40) * 1rem;
    }
    .bigEvents{
        background-color: #FFFFFF;
        width: 100%;
        height: 100%;
        padding-top: rem(84);
        position: relative;
        .title{
            position: absolute;
            top:rem(101);
            left: rem(144);
            /*color: #008C8C;*/
            color: var(--body-color);
            font-size: rem(24);
            z-index: 1;
        }
        .zhezhao1{
            width: rem(95);
            height: rem(526);
            position: absolute;
            top: rem(84);
            left: 0;
            background: linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
            filter: blur(0px);
        }
        .zhezhao2{
            width: rem(95);
            height: rem(526);
            position: absolute;
            top: rem(84);
            right: 0;
            background: linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
            filter: blur(0px);
        }
        .text{
            /*color: #008C8C;*/
            color: var(--body-color);
            text-align: center;
            p{
                margin-top: rem(59);
                font-size: rem(25);
                text-align: center;
                line-height: rem(36);
            }
            span{
                margin-top: rem(17);
                display: inline-block;
                font-size: rem(20);
                text-align: center;
                line-height: rem(36);
            }
        }

    }
    #bigEvents{
        background-color: #EBEBEB;
        padding-top: rem(57);
        padding-bottom: rem(79);
        overflow: visible;
        box-shadow: inset 0px 0px 42px 0px rgba(0, 0, 0, 0.32);

        .swiper-container {
            width: 100%;
            height: 100%;

        }
        .swiper-slide {
            width: rem(520);
            height: rem(390);
            text-align: center;
            font-size: rem(18);
            background: #fff;

            /* Center slide text vertically */
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;

            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.32);
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            img{
              width: 100%;
              height: 100%;
            }
        }
        .swiper-button-next{
            width: rem(38);
            height: rem(38);
            background: url("../../assets/img/pc/right.png") center center no-repeat;
            background-size: 100% 100%;
            top: 114%;
            right: rem(85);
        }
        .swiper-button-prev{
            top: 114%;
            left: rem(85);

            width: rem(38);
            height: rem(38);
            background: url("../../assets/img/pc/left.png") center center no-repeat;
            background-size: 100% 100%;
        }
    }


</style>
